import { useAuth } from './AuthContext';
import { useChildrenCompanies } from './ChildrenCompaniesContex';
import { useCustomization } from './CustomizationContext';
import { useHost } from './HostsContext';

export const useCentralizedValuesFallback = () => {
  const {
    selectedCustomization,
    selectedGDPR,
    selectedNDA,
    selectedCompany,
    childrenHostsList,
    searchChildrenHosts,
    selectedCompanyId,
    selectedChildrenVisitFlowTypes,
    selectedChildrenVisitFlowType,
  } = useChildrenCompanies();
  const { customization, gdpr, nda, company, visitFlowTypes, selectedVisitFlowType } =
    useCustomization();

  const { ipad } = useAuth();

  const { isFacialEnabled } = company?.visitsConfig ?? {};

  const { hostsList, searchHost } = useHost();

  const selectedOrFallbackCustomization = selectedCustomization || customization;
  const selectedOrFallbackGDPR = selectedGDPR || gdpr;
  const selectedOrFallbackNDA = selectedNDA || nda;
  const selectedOrFallbackCompany = selectedCompany || company;

  const selectedHosts = selectedCompanyId ? childrenHostsList : hostsList;

  const selectedOrFallbackVisitFlowTypes = selectedChildrenVisitFlowTypes || visitFlowTypes;
  const selectedOrFallbackVisitFlowType = selectedChildrenVisitFlowType || selectedVisitFlowType;

  const searchSelectedHost = selectedCompanyId ? searchChildrenHosts : searchHost;

  const hasFaceDetectionEnabled = ipad?.photoConfigOverrideEnabled
    ? ipad?.hasFaceRecognitionIntegration
    : isFacialEnabled;

  const searchAllFlowTypes = selectedOrFallbackCustomization?.searchAllFlowTypes;

  const shouldSkipVisitFlowTypesScreen =
    selectedOrFallbackVisitFlowTypes.length === 1 || searchAllFlowTypes;

  return {
    selectedOrFallbackCustomization,
    selectedOrFallbackGDPR,
    selectedOrFallbackNDA,
    selectedOrFallbackCompany,
    searchSelectedHost,
    selectedHosts,
    selectedOrFallbackVisitFlowTypes,
    selectedOrFallbackVisitFlowType,
    hasFaceDetectionEnabled,
    shouldSkipVisitFlowTypesScreen,
  };
};
